// 全局请求配置
import axios from "axios";
import { getToken } from "@/util/cookie";

let token = getToken() || "";
axios.defaults.headers.common["Authorization"] = "Bearer " + token;
